import { createContext, useContext } from "react";
import type { Hierarchy } from "@/lib/levels";

export interface AppState {
  mode: "live" | "demo";
  userId: string;
  userEmail: string;
  teamId: string;
  teamName: string;
  hierarchy: Hierarchy;
  units: "us" | "metric";
  signOut: () => void;
}

export const AppCtx = createContext<AppState | null>(null);

export function useApp(): AppState {
  const v = useContext(AppCtx);
  if (!v) throw new Error("useApp outside a team route");
  return v;
}
